/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Materials_FertilizerInputs */

const vi_care_log_materials_fertilizer = /** @type {(inputs: Care_Log_Materials_FertilizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bón`)
};

/**

* @param {Care_Log_Materials_FertilizerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_materials_fertilizer = /** @type {((inputs?: Care_Log_Materials_FertilizerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Materials_FertilizerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_materials_fertilizer(inputs)
});